/**
 * Calcola quanti anni totali coprono gli age breaks selezionati
 * @param ageBreaks array di stringhe nel formato "15_24", "25_34", ecc.
 * @returns numero totale di anni coperti
 */
export const getAgeBreakSpan = (ageBreaks: (string | null | undefined)[]): number => {
    if (!ageBreaks || ageBreaks.length === 0) return 0;

    return ageBreaks.reduce((acc, ab) => {
        if (!ab) return acc;

        if (ab.includes("+")) {
            const start = parseInt(ab);
            if (!isNaN(start)) {
                const assumedEnd = 100;
                return acc + (assumedEnd - start + 1);
            }
            return acc;
        }

        const [start, end] = ab.split("_").map(Number);
        if (!isNaN(start) && !isNaN(end)) {
            return acc + (end - start + 1);
        }

        return acc;
    }, 0);
};

